import { DeviceEutGroup, Examination, Project } from "graphql/types"
import { isEutGroup } from "store/typeGuards"

export const allExaminations = (project: Project): Examination[] => {
  if (!project.devices) {
    return []
  }
  const eutGroups: DeviceEutGroup[] = project.devices.filter((d) =>
    isEutGroup(d)
  ) as DeviceEutGroup[]
  const allExaminations = eutGroups.flatMap((item) => item.examinations)

  // Group examinations by ID and merge operating modes
  const examinationMap = new Map<string, Examination>()

  allExaminations.forEach((examination) => {
    const existing = examinationMap.get(examination.id)

    if (existing) {
      // Merge operating modes from all examinations with same ID
      const allOperatingModes = new Set([
        ...(existing.operatingModes || []),
        ...(examination.operatingModes || []),
      ])

      examinationMap.set(examination.id, {
        ...existing,
        operatingModes: Array.from(allOperatingModes),
      })
    } else {
      examinationMap.set(examination.id, examination)
    }
  })

  return Array.from(examinationMap.values())
}

export const allExaminationsMore = (projects: Project[]): Examination[] => {
  const devices = projects.flatMap((p) => p.devices)
  const eutGroups: DeviceEutGroup[] = devices.filter((d) => isEutGroup(d)) as DeviceEutGroup[]
  const allExaminations = eutGroups.flatMap((item) => item.examinations)

  // Group examinations by ID and merge operating modes
  const examinationMap = new Map<string, Examination>()

  allExaminations.forEach((examination) => {
    const existing = examinationMap.get(examination.id)

    if (existing) {
      // Merge operating modes from all examinations with same ID
      const allOperatingModes = new Set([
        ...(existing.operatingModes || []),
        ...(examination.operatingModes || []),
      ])

      examinationMap.set(examination.id, {
        ...existing,
        operatingModes: Array.from(allOperatingModes),
      })
    } else {
      examinationMap.set(examination.id, examination)
    }
  })

  return Array.from(examinationMap.values())
}

export const allExaminationsUnique = (project: Project): Examination[] => {
  if (!project.devices) {
    return []
  }

  const eutGroups: DeviceEutGroup[] = project.devices.filter((d) =>
    isEutGroup(d)
  ) as DeviceEutGroup[]

  const allExaminations = eutGroups.flatMap((item) => item.examinations || [])

  // Group examinations by ID and merge operating modes
  const examinationMap = new Map<string, Examination>()

  allExaminations.forEach((examination) => {
    const existing = examinationMap.get(examination.id)

    if (existing) {
      // Merge operating modes from all examinations with same ID
      const allOperatingModes = new Set([
        ...(existing.operatingModes || []),
        ...(examination.operatingModes || []),
      ])

      examinationMap.set(examination.id, {
        ...existing,
        operatingModes: Array.from(allOperatingModes),
      })
    } else {
      examinationMap.set(examination.id, examination)
    }
  })

  return Array.from(examinationMap.values())
}
